import { Component, OnInit, AfterViewInit } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ExportExcelService } from 'app/service/export-excel.service'
import { DatePipe } from '@angular/common'
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-marcro-data',
  templateUrl: './marcro-data.component.html',
  styleUrls: ['./marcro-data.component.scss']
})
export class MarcroDataComponent implements OnInit, AfterViewInit {
  listExchangeMacro = []
  countrys = []
  compositionName = []
  sectorName = []
  colspan

  marketCap = []
  avgTrading = []
  gdp = []
  indexChange = []
  dividendYield = []
  pe = []
  roe = []
  asOfDate
  getPrint
  indexLastPrice = []
  gdpUSD = 'GDP (bn USD)'
  gdpComposition = 'GDP composition (%)'
  gdpBysector = 'GDP by sector (%)'
  cia = 'Source: CIA'
  stock_market = 'Stock market'
  marketCapStr = 'Market cap (M. USD)'
  avgTradingStr = 'Daily avg trade YTD (bn USD)'
  source_World = 'Source: World Federation of Exchanges'
  stock_bloomberg = 'Stock market (Bloomberg)'
  indexChangeStr = 'Index performance YTD (%)'
  dividendYieldStr = 'Dividend yield (%)'
  peStr = 'PE ratio (x)'
  roeStr = 'ROE (%)'
  s_bloomberg = 'Source: Bloomberg'
  imf = 'Source: IMF'
  indexLast = 'Index'

  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private excelService: ExportExcelService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { print } = this.activatedRoute.snapshot.data
    this.getPrint = print
    this.getExchangeMacro()
  }

  async getExchangeMacro() {
    await this.cpmService.getExchangeMacro().then(obj => {
      this.asOfDate = this.datePipe.transform(obj.asOfDate, 'd MMM yyyy')
      this.listExchangeMacro = obj.macroData.map(data => {
        this.countrys.push(data.country)
        data.gdpComposition.map(composition => {
          this.compositionName.push(composition.compositionName)
        })
        data.gdpBySector.map(sector => {
          this.sectorName.push(sector.sectorName)
        })

        data.gdpBySector.push({
          sectorName: 'Bank lending rate (%)',
          gdp: data.bankLendingRate
        })

        this.marketCap.push(Number(parseFloat(data.marketCap).toFixed(0)));
        this.avgTrading.push(Number(parseFloat(data.avgTrading).toFixed(0)));
        this.gdp.push(data.gdp)
        // this.indexChange.push(data.indexChange)

        const indexChangeValue = Number(parseFloat(data.indexChange).toFixed(2));
        this.indexChange.push(indexChangeValue);
        data.indexChange = indexChangeValue;

        this.indexLastPrice.push(data.indexLastPrice)
        this.dividendYield.push(data.dividendYield);
        this.pe.push(data.pe);
        this.roe.push(data.roe);

        return data
      })

      this.countrys.push('Total')
      this.compositionName = this.compositionName.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])

      this.sectorName = this.sectorName.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])

      this.sectorName.push('Bank lending rate (%)')

      const total = {
        country: 'Total',
        market: 'Total',
        gdp: this.gdp.reduce((a, b) => a + b, 0),
        gdpComposition: [],
        gdpBySector: [],
        bankLendingRate: null,
        marketCap: this.marketCap.reduce((a, b) => a + b, 0),
        avgTrading: this.avgTrading.reduce((a, b) => a + b, 0),
        indexLastPrice: null,
        indexChange: null,
        dividendYield: null,
        pe: null,
        roe: null
      }
      this.listExchangeMacro.push(total)
      this.gdp.push(total.gdp)
      this.marketCap.push(total.marketCap)
      this.avgTrading.push(total.avgTrading)
    })
  }

  getTotalgdpComposition(compositionName, obj) {
    const gdpComposition = compositionName.map(comName => {
      const groupBycompositionName = {}
      const list = []
      groupBycompositionName['compositionName'] = comName
      obj.macroData.map(data => {
        data.gdpComposition.map(composition => {
          if (comName === composition.compositionName) {
            list.push(composition.gdp)
          }
        })
      })
      groupBycompositionName['gdp'] = null
      return groupBycompositionName
    })
    return gdpComposition
  }

  getTotalgdpBySector(sectorNames, obj) {
    const gdpSector = sectorNames.map(sectorName => {
      const groupBysectorName = {}
      const list = []
      groupBysectorName['sectorName'] = sectorName
      obj.macroData.map(data => {
        data.gdpBySector.map(sec => {
          if (sectorName === sec.sectorName) {
            list.push(sec.gdp)
          }
        })
      })
      groupBysectorName['gdp'] = null
      return groupBysectorName
    })
    return gdpSector
  }

  dataToExcel() {
    const ws_data = []
    ws_data.push([' ', ...this.countrys])

    ws_data.push([this.gdpUSD, ...this.gdp])

    ws_data.push([this.gdpComposition])
    this.compositionName.map(composition => {
      const list = []
      list.push(composition)
      this.listExchangeMacro.map(compo => {
        compo.gdpComposition.map(gdpObj => {
          if (gdpObj.compositionName === composition) {
            list.push(gdpObj.gdp)
          }
        })
      })
      ws_data.push([...list])
    })
    ws_data.push([this.imf])
    ws_data.push([this.gdpBysector])

    this.sectorName.map(sectorName => {
      const list = []
      list.push(sectorName)
      this.listExchangeMacro.map(data => {
        data.gdpBySector.map(sec => {
          if (sectorName === sec.sectorName) {
            list.push(sec.gdp)
          }
        })
      })
      ws_data.push([...list])
    })

    ws_data.push([this.cia])
    ws_data.push([this.stock_market])

    ws_data.push([this.marketCapStr, ...this.marketCap])
    ws_data.push([this.avgTradingStr, ...this.avgTrading])

    ws_data.push([this.source_World])

    ws_data.push([this.stock_bloomberg])
    ws_data.push([this.indexLast, ...this.indexLastPrice])
    ws_data.push([this.indexChangeStr, ...this.indexChange])
    ws_data.push([this.dividendYieldStr, ...this.dividendYield])

    ws_data.push([this.peStr, ...this.pe])
    ws_data.push([this.roeStr, ...this.roe])

    ws_data.push([this.s_bloomberg])

    this.excelService.exportExcelData(ws_data, 'Macro Data')
  }

  numberToNoDecimal(num) {
    return Number(parseFloat(num).toFixed(0)).toLocaleString('en')
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/marcro-data/marcro-data.component.ts